import { AnyAction, createReducer, isAnyOf } from '@reduxjs/toolkit';

import { loadersBuilder, logoutBuilder } from '@modules/builders';
import { buyActions } from '@modules/buy';
import { WritableStore } from '@modules/helpers';
import { sellActions } from '@modules/sell';
import { withdrawActions } from '@modules/withdraw';

import operationBlockActions from './actions';
import initialState from './state';

const setConsentRequired = (state: WritableStore<typeof initialState>, action: AnyAction) => {
  const { consent_required } = action.payload.data;

  if (consent_required) state.consentRequired = consent_required;
  else if (state.consentRequired) delete state.consentRequired;
};

export const operationBlockReducer = createReducer(initialState, builder => {
  builder.addCase(operationBlockActions.setLeft, (state, action) => {
    state.paymentSelect.left = {
      group: action.payload.group,
      value: action.payload.value,
    };
    if (state.consentRequired) delete state.consentRequired;
  });

  builder.addCase(operationBlockActions.setRight, (state, action) => {
    state.paymentSelect.right = {
      group: action.payload.group,
      value: action.payload.value,
    };
    if (state.consentRequired) delete state.consentRequired;
  });

  builder.addMatcher(
    isAnyOf(
      sellActions.getSellRate.fulfilled,
      buyActions.getBuyRate.fulfilled,
      withdrawActions.getWithdrawRate.fulfilled
    ),
    setConsentRequired
  );
  logoutBuilder(initialState, builder, []);
  loadersBuilder('operationBlock', builder);
});

export { operationBlockActions };
